export default "__VITE_ASSET__f33b860d__"